(() => {
  const normalizeColorKey = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '');

  const initLookSliders = () => {
    document.querySelectorAll('.solvia-look').forEach((section) => {
      if (section.dataset.solviaLookSlider === 'true') return;

      const track = /** @type {HTMLElement | null} */ (section.querySelector('[data-look-track]'));
      const slides = Array.from(section.querySelectorAll('[data-look-slide]'));
      const dots = Array.from(section.querySelectorAll('[data-look-dot]'));
      if (!track || slides.length < 2 || dots.length < 2) return;

      section.dataset.solviaLookSlider = 'true';

      const setCurrent = (index) => {
        dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
        });
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number(dot.dataset.lookIndex || 0);
          const slide = /** @type {HTMLElement | undefined} */ (slides[index]);
          slide?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          setCurrent(index);
        });
      });

      let frame = 0;
      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(() => {
          const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          setCurrent(Math.max(0, Math.min(index, dots.length - 1)));
        });
      }, { passive: true });
    });
  };

  const getSelectedColorKey = () => {
    const picker = document.querySelector('variant-picker');
    if (!picker) return '';

    const colorInput = picker.querySelector(
      '.variant-option legend:is(:not(:empty)) ~ label input[type="radio"]:checked'
    );
    const colorFieldset = Array.from(picker.querySelectorAll('.variant-option')).find((fieldset) => {
      const legend = fieldset.querySelector('legend')?.textContent?.trim().toLowerCase() || '';
      return legend.startsWith('color') || legend.startsWith('カラー');
    });
    const checkedColorInput = colorFieldset?.querySelector('input[type="radio"]:checked');

    return normalizeColorKey(checkedColorInput?.value || colorInput?.value || '');
  };

  const updateRelatedProducts = () => {
    const selectedColorKey = getSelectedColorKey();
    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    document.querySelectorAll('.solvia-related__grid').forEach((grid) => {
      let visibleCount = 0;

      grid.querySelectorAll('.solvia-related__item[data-related-color-key]').forEach((item) => {
        const itemColorKey = item.dataset.relatedColorKey || '';
        const isSelectedColor = itemColorKey === selectedColorKey;
        const exceedsDesktopLimit = !isMobile && !isSelectedColor && visibleCount >= 4;
        const shouldHide = isSelectedColor || exceedsDesktopLimit;

        item.hidden = shouldHide;
        if (!shouldHide) visibleCount += 1;
      });
    });
  };

  const initRelatedProducts = () => {
    updateRelatedProducts();
  };

  const onVariantPickerChange = (event) => {
    if (!event.target?.closest?.('variant-picker')) return;
    window.requestAnimationFrame(updateRelatedProducts);
  };

  let resizeFrame = 0;
  const onResize = () => {
    window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(updateRelatedProducts);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initLookSliders();
      initRelatedProducts();
    }, { once: true });
  } else {
    initLookSliders();
    initRelatedProducts();
  }

  document.addEventListener('shopify:section:load', initLookSliders);
  document.addEventListener('shopify:section:load', initRelatedProducts);
  document.addEventListener('shopify:section:reorder', () => {
    initLookSliders();
    initRelatedProducts();
  });
  document.addEventListener('change', onVariantPickerChange);
  window.addEventListener('resize', onResize, { passive: true });
})();
